<!--
 * @Author: your name
 * @Date: 2021-07-30 14:32:11
 * @LastEditTime: 2021-11-03 16:39:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\stock\init\components\DataForm.vue
-->
<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="180px"
    @handleConfirm="handleConfirm"
  >
    <BjDivider>{{ $t('StockStructureConfiguration.Form.Create') }}</BjDivider>
    <el-form-item :label="$t('StockStructureConfiguration.Form.Code')">
      <BjInput :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('StockStructureConfiguration.Form.pps')" clearable disabled />
    </el-form-item>
    <el-form-item :label="$t('StockStructureConfiguration.Form.Name')" prop="name">
      <BjInput
        v-model="form.name"
        :maxlength="MAX_LENGTH.DEFAULT"
        :placeholder="$t('inputText')"
        clearable
      />
    </el-form-item>
  </BjDrawerForm>
</template>
<script>
import { stockApi } from '@/api';
const getDefaultForm = () => {
  return {
    tenantId: 0,
    name: '',
  };
};
export default {
  data() {
    return {
      form: getDefaultForm(),
    };
  },
  computed: {
    rules() {
      const rules = {
        name: [{ required: true, message: this.$t('StockStructureConfiguration.Form.ps'), trigger: 'blur' }],
      };
    return rules;
    }
  },
  methods: {
    show(info) {
      if (!info) {
        this.form = getDefaultForm();
      }
      this.$refs.BjDrawerForm.show();
    },
    handleClose() {
      this.$refs.BjDrawerForm.hide();
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }

      this.addApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },

    addApi(API_DATA) {
      stockApi.addWarehouseStructures(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.handleClose();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-item {
  width: 200px;
  justify-content: space-between;
  align-items: flex-start;
}
</style>
